// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zrnS","question":"styles_question__1Dwnz","description":"styles_description__3yKy0"};